import React, { useContext } from 'react';
import { DataContext } from '../../entries/common/widgets/project-configuration/context';
import { InteriorDoorsForm } from './forms/interior-doors/interior-doors';
import { LaminateForm } from './forms/laminate/laminate';
import { isLaminate } from './helpers/is-laminate';

export const Content = () => {
  const data = useContext(DataContext);
  const isLaminateType = isLaminate(data!.type);

  if (isLaminateType) {
    return <LaminateForm />;
  }

  return <InteriorDoorsForm />;
};
